// dispatchPortal modules
import axios from '@/api/http_client';
import { DISPATCH_PORTAL_URL } from '../../api/url'; // eslint-disable-line import/no-extraneous-dependencies, import/extensions

export const dispatchPortalOrdersDesiredShape = {
  orders: data => data.orders && data.orders.map(order => ({
    orderNum: order.order_num,
    customerName: order.customer_name,
    address: order.address,
    city: order.city,
    state: order.state,
    zipcode: order.zipcode,
    phone: order.phone,
  })),
};

// initial state
const state = {
  password: '',
}

// actions
const actions = {
  fetchDispatchPortalOrders(context, accessCode, desiredShape = dispatchPortalOrdersDesiredShape) {
    const config = {
      method: 'get',
      url: DISPATCH_PORTAL_URL,
      params: {
        password: accessCode,
      },
      headers: {
        Authorization: `JWT ${token}`,
     },
    };
    axios(config)
    .then((response) => {
      context.commit('fetchDispatchPortal');
    }, (err) => {
      if (err.response.status === 401) {

      }
    })

  },

};

// mutations
const mutations = {
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dispatchPortal.js